import React, { useEffect, useState } from "react";
import { RefreshCw, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const TwilioCostSyncCard = ({ onSynced }) => {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/rates/sync-status").then(({ data }) => setStatus(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  useEffect(() => {
    if (!status?.running) return;
    const t = setInterval(async () => {
      const { data } = await api.get("/admin/rates/sync-status");
      setStatus(data);
      if (!data.running) { clearInterval(t); setBusy(false); onSynced?.(); toast.success(`Costs synced — ${data.changed} of ${data.total} destinations changed`); }
    }, 3000);
    return () => clearInterval(t);
  }, [status?.running]); // eslint-disable-line react-hooks/exhaustive-deps

  const run = async () => {
    setBusy(true);
    try { await api.post("/admin/rates/sync-twilio"); setStatus((s) => ({ ...(s || {}), running: true })); }
    catch (e) { toast.error(e.response?.data?.detail || "Sync failed"); setBusy(false); }
  };

  return (
    <div className="bg-white border border-black/10 rounded-2xl p-5 shadow-sm mb-6 flex flex-wrap items-center justify-between gap-3" data-testid="twilio-cost-sync-card">
      <div>
        <div className="font-heading font-bold flex items-center gap-2"><RefreshCw className="h-4 w-4 text-primary" /> Costs follow Twilio automatically</div>
        <p className="text-sm text-zinc-500 mt-0.5">
          Every destination&rsquo;s cost is refreshed daily from Twilio&rsquo;s live price list; user prices = cost + your margin.
          {status?.synced_at && <> Last sync: <b>{new Date(status.synced_at).toLocaleString()}</b> · {status.changed} changed.</>}
        </p>
      </div>
      <button onClick={run} disabled={busy || status?.running} data-testid="twilio-cost-sync-button"
        className="h-11 px-5 rounded-xl border border-black/10 font-semibold hover:border-primary/40 flex items-center gap-2 disabled:opacity-60">
        {(busy || status?.running) ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} Sync now
      </button>
    </div>
  );
};
